import script from "./BotPreviewModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BotPreviewModal.vue?vue&type=script&lang=ts&setup=true"

import "./BotPreviewModal.vue?vue&type=style&index=0&id=5470ea6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5470ea6a"]])

export default __exports__